import { getAllTransactions } from '../../constructs/transactions/selectors';
import { getLuaEditorData } from '../../constructs/handlers/selectors';
import { constructIds, getConstructType, treeNodesLabel } from '../../../config/common';

export const getEvents = (state) => {
    return state.constructs.events;
}

export const getAllEvents = (state) => state.constructs.events

export const getTransactionEvents = (transaction, state) => {
    let events = []
    transaction.events.forEach(e => events.push(e.id))
    return state.constructs.events.filter(e => events.includes(e.id))
}

export const getTransactionEvents1 = (state) => {

    let currentTransaction = state.global.selectedTransactionId;
    if (currentTransaction?.templateTransaction == true) {
        //Template transaction, manually modified
        let events = currentTransaction.events.map(e => e.id);
        return [];
    }


    const transaction = state.constructs.transactions.find(trans => trans.id === currentTransaction)
    let events = []
    transaction.events.forEach(e => events.push(e.id))
    return state.constructs.events.filter(e => events.includes(e.id))
}

export const getNestedTransactionsAndNestedTransactionEvents = (state) => {

    let currentTransaction = state.global.selectedTransactionId;

    //for template transactions
    if (currentTransaction?.templateTransaction == true) {
        return {
            nestedTransactions: [],
            nestedTransactionEvents: []
        }
    }

    const transaction = state.constructs.transactions.find(trans => trans.id === currentTransaction)
    const nestedTransactionsIds = transaction.nestedTransactions.map(trans => trans.id)

    const nestedTrans = state.constructs.transactions.map(trans => {
        if (nestedTransactionsIds.includes(trans.id)) return trans
    }).filter(i => i)

    let events = []
    nestedTrans.forEach(nestedTrans => {
        nestedTrans?.events?.forEach(event => events.push(event.id))
    })

    return {
        nestedTransactions: nestedTrans,
        nestedTransactionEvents: state.constructs.events.filter(e => events.includes(e.id))
    }

}

export const getEventDependencies = (payload) => (state) => {
    const { eventId } = payload;

    return state.constructs.rrdefs.filter(rrdef => rrdef.attributes.tcmd === eventId)
}

export const getOutgoingEventsFromClusterlet = (payload) => state => {

    const { from } = payload;
    let transactions = getAllTransactions(state);
    let events = getAllEvents(state);
    let handlers = getLuaEditorData(state);
    let eventInfo = [];

    transactions.forEach(transaction => {
        const sortedEvents = transaction.events.sort((a, b) => a.order - b.order);
        sortedEvents.forEach(item => {
            const event = events.find(e => e.id === item.id && e.src === from)
            let onrecvHandler = {}
            let onsendHandler = {}
            if (event?.attributes?.onrecv) {
                const onrecv = handlers.find(handler => handler.type === 'onrecv' && handler.event === event.id)
                if (onrecv) onrecvHandler = onrecv
            }
            if (event?.attributes?.onsend) {
                const onsend = handlers.find(handler => handler.type === 'onsend' && handler.event === event.id)
                if (onsend) onsendHandler = onsend
            }
            if (event) eventInfo.push({ transaction: transaction, event: event, handlers: { onrecvHandler, onsendHandler } })
        })
    })
    return eventInfo
}

export const getIncomingEventsToClusterlet = (payload) => state => {

    const { to } = payload;
    let transactions = getAllTransactions(state);
    let events = getAllEvents(state);
    let handlers = getLuaEditorData(state);
    let eventInfo = [];

    transactions.forEach(transaction => {
        const sortedEvents = transaction.events.sort((a, b) => a.order - b.order);
        sortedEvents.forEach(item => {
            const event = events.find(e => e.id === item.id && e.dst === to)
            if (event) {
                let onrecvHandler = {}
                let onsendHandler = {}
                if (event.attributes.onrecv) {
                    const onrecv = handlers.find(handler => handler.type === 'onrecv' && handler.event === event.id)
                    if (onrecv) onrecvHandler = onrecv
                }
                if (event.attributes.onsend) {
                    const onsend = handlers.find(handler => handler.type === 'onsend' && handler.event === event.id)
                    if (onsend) onsendHandler = onsend
                }
                if (event) eventInfo.push({ transaction: transaction, event: event, handlers: { onrecvHandler, onsendHandler } })
            }
        })
    })
    return eventInfo
}

export const transactionEvents = ({ transactionId }) => (state) => {

    if (transactionId == null)
        return [];

    const transaction = state.constructs.transactions.find(trans => trans.id === transactionId)
    let handlers = getLuaEditorData(state);

    let eventInfo = []
    const transactionEvents = state.constructs.events
        .filter(e => transaction?.events?.map(item => item.id).includes(e.id))
        .sort(function (a, b) {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        });

    transactionEvents.forEach(item => {
        let onrecvHandler = {}
        let onsendHandler = {}
        if (item.attributes.onrecv) {
            const onrecv = handlers.find(handler => handler.type === 'onrecv' && handler.event === item.id)
            if (onrecv) onrecvHandler = onrecv
        }
        if (item.attributes.onsend) {
            const onsend = handlers.find(handler => handler.type === 'onsend' && handler.event === item.id)
            if (onsend) onsendHandler = onsend
        }
        eventInfo.push({ transaction: transaction, event: item, handlers: { onrecvHandler, onsendHandler } })
    });

    return eventInfo;
}

export const getEventClusterletsInfo = payload => state => {

    const { id } = payload;
    const event = state.constructs.events.find(item => item.id === id)

    const srcClusterlet = state.constructs.clusterlets.find(item => item.id === event.src)
    const srcType = getConstructType(srcClusterlet.type);

    const dstClusterlet = state.constructs.clusterlets.find(item => item.id === event.dst)
    const dstType = getConstructType(dstClusterlet.type);

    const srcHandler = state.constructs.handlers.find(item => item.clusterlet === srcClusterlet.id && item.event === id)
    if (srcHandler) srcHandler.name = `${srcHandler.type}_${srcClusterlet.name}`

    const dstHandler = state.constructs.handlers.find(item => item.clusterlet === dstClusterlet.id && item.event === id)
    if (dstHandler) dstHandler.name = `${dstHandler.type}_${dstClusterlet.name}`

    let srcInstance = ""
    let dstInstance = ""

    if (srcType === "external_function") {
        srcInstance = state.constructs.bootloaders.find(item => item.attributes.type === srcClusterlet.id).name
    } else {
        srcInstance = '[dynamic instance]';
    }

    if (dstType === 'external_function') {
        dstInstance = state.constructs.bootloaders.find(item => item.attributes.type === dstClusterlet.id).name
    } else {
        const rrdef = state.constructs.rrdefs.find(item => item.attributes.tcmd === id)
        dstInstance = rrdef ? rrdef.attributes?.tinstance : event?.instance ? event.instance : '[dynamic instance]';

    }

    return [
        {
            role: "Source",
            clusterlet: srcClusterlet,
            instance: srcInstance,
            handler: srcHandler,
            type: treeNodesLabel[constructIds.find(element => element.id === srcClusterlet.type).type]
        },
        {
            role: "Destination",
            clusterlet: dstClusterlet,
            instance: dstInstance,
            handler: dstHandler,
            type: treeNodesLabel[constructIds.find(element => element.id === dstClusterlet.type).type]
        }

    ]
}


export const getFirstEventsInOrder = (state) => {

    let eventsArray = []
    state.constructs.events.map(event => {
        state.constructs.clusterlets.map(clusterlet => {
            if (event.src == clusterlet.id && clusterlet.type == 1) {
                eventsArray.push(event)
            }
        })
    })

    return eventsArray
}

export const getClusterletEvents = (clusterletIds, state) => {

    const eventsList = [];


    const transEvents = clusterletIds.map(clusterlet => {
        state.constructs.events.map(event => {
            if (event.src == clusterlet || event.dst == clusterlet) {
                const eventExist = eventsList.find(ev => ev.id == event.id);
                if (eventExist == undefined) eventsList.push(event)
            }
        })
    })

    return eventsList

}

export const getTransactionAssociatedEvents = (transaction) => state => {

    let eventsList = [];
    let eventsInTransaction = transaction?.events;

    eventsInTransaction.map(eventInTrans => {
        state.constructs.events.map(event => {
            if (event.id === eventInTrans.id) {
                eventsList.push(event)
            }
        })
    })

    return eventsList;
}

export const getUserTriggersAndRrdefsOfAnEvent = (eventId) => state => {

    let userTriggers = state.constructs.user_triggers.filter(item => item.attributes.op === eventId)

    let rrdefs = state.constructs.rrdefs.filter(item => item.attributes.tcmd === eventId)

    let handlers = state.constructs.handlers.filter(item => item.event === eventId)
    // console.log({userTriggers, rrdefs, handlers})

    return {
        userTriggers,
        rrdefs,
        handlers
    }

}

